exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".in-locations[data-v-f94427a0] {\n  color: #2368c5;\n  font-size: 11pt;\n  cursor: pointer;\n}\n.in-locations[data-v-f94427a0]:hover {\n  color: #333;\n  text-decoration: underline;\n}\n.locations .list-item[data-v-f94427a0] {\n  padding: 10px;\n}\n", ""]);
